import React from 'react';
import Input from '../Input/Input';

export default function SearchField(props) {
  return <Input type="search" {...props} />;
}
